import {
  API_ERROR,
  RFQ_LIST,
  RFQ_LIST_SUCCESS,
  Q_VENDORS_LIST,
  Q_VENDORS_LIST_SUCCESS,
  INPUT_CHANGEVALUE,
  RFQ_NO_SELECT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  RFQ_ROW_DATA,
  RFQ_ROW_DATA_SUCCESS,
  QITEM_REMOVE,
  ITEM_QTY_CHANGEVALUE,
  ITEM_UNIT_CHANGEVALUE,
  ITEM_PRICE_CHANGEVALUE,
  ITEM_DISC_PERCENT_CHANGEVALUE,
  ITEM_BASEPRICE_CHANGEVALUE,
  ITEM_TAXTYPE_CHANGEVALUE,
  ITEM_TAX_CHANGEVALUE,
  ITEM_GROSS_VAL_CHANGEVALUE,
  ITEM_QUALITIES_CHANGEVALUE,
  QUOTATION_ADD,
  QUOTATION_LIST,
  QUOTATION_LIST_SUCCESS,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  TOGGLE_ITEM_MENU,
  Q_MODEL_LIST_OPEN,
  Q_MODEL_LIST_CLOSE,
  QOUTATION_DATA,
  QOUTATION_DATA_SUCCESS,
  LIST_LAYOUT,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  RFQ_FILTERS_LIST,
  RFQ_FILTERS_LIST_SUCCESS,
  MR_CODE_DETAILS,
  MR_CODE_DETAILS_SUCCESS,
  PI_CODE_DETAILS,
  PI_CODE_DETAILS_SUCCESS,
  MR_ITEM_IMAGES,
  MR_ITEM_IMAGES_SUCCESS,
  RFQ_MR_ITEM_IMAGES_MODEL_CLOSE,
  SRFQ_FILTERS_LIST,
  SRFQ_FILTERS_LIST_SUCCESS,
  RFQ_WITHOUT_PO_LIST,
  RFQ_WITHOUT_PO_LIST_SUCCESS,
} from "./actionTypes";

export const getRFQList = (data) => {
  return {
    type: RFQ_LIST,
    payload: { data },
  };
};
export const getRFQListSuccessful = (response) => {
  return {
    type: RFQ_LIST_SUCCESS,
    payload: response,
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const rfqNoSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: RFQ_NO_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getRFQRequestdata = (rfqId, byVendor) => {
  return {
    type: RFQ_ROW_DATA,
    payload: { rfqId, byVendor },
  };
};
export const getRFQRequestdataSuccessful = (request) => {
  return {
    type: RFQ_ROW_DATA_SUCCESS,
    payload: request,
  };
};
export const QItemRemove = (data) => {
  return {
    type: QITEM_REMOVE,
    payload: data,
  };
};
export const getQuotationtVendorsList = (rfqId) => {
  return {
    type: Q_VENDORS_LIST,
    payload: { rfqId },
  };
};
export const QuotationtVendorsListSuccessful = (response) => {
  return {
    type: Q_VENDORS_LIST_SUCCESS,
    payload: response,
  };
};

export const itemQtyChangeValue = ({ key, value, item }) => {
  return {
    type: ITEM_QTY_CHANGEVALUE,
    payload: { key, value, item },
  };
};
export const itemUnitSelecteChangeValue = ({
  key,
  label,
  key2,
  value,
  item,
}) => {
  return {
    type: ITEM_UNIT_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};
export const itemPriceChangeValue = ({
  key,
  value,
  discount,
  discountpercent,
  item,
}) => {
  return {
    type: ITEM_PRICE_CHANGEVALUE,
    payload: { key, value, discount, discountpercent, item },
  };
};
export const itemDiscountPercentChangeValue = ({
  key,
  value,
  price,
  discount,
  item,
}) => {
  return {
    type: ITEM_DISC_PERCENT_CHANGEVALUE,
    payload: { key, value, price, discount, item },
  };
};
export const itemBasePriceChangeValue = ({
  key,
  value,
  price,
  discount,
  item,
}) => {
  return {
    type: ITEM_BASEPRICE_CHANGEVALUE,
    payload: { key, value, price, discount, item },
  };
};

export const itemTaxTypeSelecteChangeValue = ({
  key,
  label,
  key2,
  value,
  item,
}) => {
  return {
    type: ITEM_TAXTYPE_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};
export const itemTaxSelecteChangeValue = ({ id, name, tax, item }) => {
  return {
    type: ITEM_TAX_CHANGEVALUE,
    payload: { id, name, tax, item },
  };
};
export const itemGrossValChangeValue = (taxamt, net, item) => {
  return {
    type: ITEM_GROSS_VAL_CHANGEVALUE,
    payload: { taxamt, net, item },
  };
};
export const quotationAdd = (data, qoutId, history) => {
  return {
    type: QUOTATION_ADD,
    payload: { data, qoutId, history },
  };
};
export const getQuotationtList = (data) => {
  return {
    type: QUOTATION_LIST,
    payload: { data },
  };
};
export const QuotationtListSuccessful = (response) => {
  return {
    type: QUOTATION_LIST_SUCCESS,
    payload: response,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};
export const Q_model_list_open = (qId) => {
  return {
    type: Q_MODEL_LIST_OPEN,
    payload: { qId },
  };
};
export const Q_model_list_close = () => {
  return {
    type: Q_MODEL_LIST_CLOSE,
  };
};
export const getQuotationData = (qId) => {
  return {
    type: QOUTATION_DATA,
    payload: { qId },
  };
};
export const QuotationDatasuccessfull = (quotation) => {
  return {
    type: QOUTATION_DATA_SUCCESS,
    payload: quotation,
  };
};
export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const getRFQFilterList = (data) => {
  return {
    type: RFQ_FILTERS_LIST,
    payload: { data },
  };
};
export const getRFQFilterListSuccessful = (response) => {
  return {
    type: RFQ_FILTERS_LIST_SUCCESS,
    payload: response,
  };
};

export const getSRFQFilterList = (data) => {
  return {
    type: SRFQ_FILTERS_LIST,
    payload: { data },
  };
};
export const getSRFQFilterListSuccessful = (response) => {
  return {
    type: SRFQ_FILTERS_LIST_SUCCESS,
    payload: response,
  };
};

export const getRFQWithoutPOList = (data) => {
  return {
    type: RFQ_WITHOUT_PO_LIST,
    payload: { data },
  };
};
export const getRFQWithoutPOListSuccessful = (response) => {
  return {
    type: RFQ_WITHOUT_PO_LIST_SUCCESS,
    payload: response,
  };
};

export const getMRCodeDetails = (ItemId) => {
  return {
    type: MR_CODE_DETAILS,
    payload: { ItemId },
  };
};
export const getMRCodeDetailsSuccessful = (response) => {
  return {
    type: MR_CODE_DETAILS_SUCCESS,
    payload: response,
  };
};
export const getPICodeDetails = (ItemId) => {
  return {
    type: PI_CODE_DETAILS,
    payload: { ItemId },
  };
};
export const getPICodeDetailsSuccessful = (response) => {
  return {
    type: PI_CODE_DETAILS_SUCCESS,
    payload: response,
  };
};
export const getMRItemImges = (rfqItemId) => {
  return {
    type: MR_ITEM_IMAGES,
    payload: { rfqItemId },
  };
};
export const getMRItemImgesSuccessful = (response) => {
  return {
    type: MR_ITEM_IMAGES_SUCCESS,
    payload: response,
  };
};
export const RFQMRItemImagesModel_close = () => {
  return {
    type: RFQ_MR_ITEM_IMAGES_MODEL_CLOSE,
    payload: null,
  };
};
export const itemQualitiesChangeValue = ({ item, qualities }) => {
  return {
    type: ITEM_QUALITIES_CHANGEVALUE,
    payload: { item, qualities },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
